<mat-form-field class="w-100" [tcTooltip]="tooltipText" [placement]="tooltipPlacement">
    <mat-label>{{ name }}</mat-label>
    <input
        matInput
        type="number"
        [(ngModel)]="value"
        (ngModelChange)="_onChangeCallback($event)"
        (blur)="_onTouchedCallback()"
        autocomplete="off"
        [required]="isRequired"
        [disabled]="isDisabled"
        step="1"
        [min]="minValue"
        [max]="maxValue"
        #control="ngModel"
    />
    <mat-error *ngIf="control.hasError('required')">
        {{ 'validators.required' | translate: _locale.language }}
    </mat-error>
    <mat-error *ngIf="control.hasError('min')">
        {{ 'validators.min' | translate: _locale.language }}
    </mat-error>
    <mat-error *ngIf="control.hasError('max')">
        {{ 'validators.max' | translate: _locale.language }}
    </mat-error>
</mat-form-field>
